var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "sub_top"
  }, [_c('SubTitle'), _vm._m(0)], 1), _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "info_section"
  }, [_vm._m(1), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@/style/new/images/info/platform_01.png`),
      "alt": ""
    }
  })])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_tit"
  }, [_c('div', {
    staticClass: "sub_tit_inner"
  }, [_c('h2', [_vm._v("공유플랫폼의 중요성")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_txt"
  }, [_c('p', {
    staticClass: "txt_typ_1"
  }, [_vm._v("소재연구데이터 중, 90% 이상이")]), _c('p', {
    staticClass: "txt_typ_2"
  }, [_vm._v("\"측정·분석데이터\"")])]);

}]

export { render, staticRenderFns }